module.exports = __webpack_public_path__ + "media/images/gifts/books/sug_livros_4-bdb45af4ffcb3f65006ecbe6e178e936.jpeg";